import * as React from "react";
import { connect } from "react-redux";
import * as S from "@styled";
import * as _ from "lodash";
import download from "downloadjs";

import { ProcessImporter } from "../../shared/components/ProcessImporter";
import { ImportSettings } from "../../shared/model/ImportModel";
import * as DeployActions from "../actions/DeployActions";
import { doImport } from "../actions/ImportActions";
import * as LogLevelActions from "../actions/LogLevelActions";
import * as Actions from "../actions/ProcessListActions";

import { getNewLink } from "../model/AppLinks";

import { AgentGroup } from "../../shared/model/AgentGroup";
import { State } from "../model/State";

import { Permissions } from "../../shared/model/AllPermissions";
import { DispatchType, Utilities } from "../../shared/utilities";

import { default as ActionMenu } from "./ActionMenu";
import { default as Search } from "./Search";
import { importIcon } from "shared/icons/svgHelpers";

export const ListMenu: React.FC<ListMenuProps> = (props) => {

    const isDefaultEnv: boolean = props.currentAgentGroupName === DeployActions.DEFAULT_AGENT_GROUP_NAME;
    const processSelected: boolean = props.selectedProcesses != null && props.selectedProcesses.length > 0;

    const saveAllAsCSVhandler = async () => {
        try {
            const processExport = await Utilities.getFetchWithHeaders(`api/processList/downloadAll/${props.currentAgentGroupName}`, {
                subProcesses: props.isSubprocessList ? "true" : "false"
            });
            const fileName = Utilities.parseFileNameFromContentDisposition(processExport.headers.get("Content-Disposition"));
            download(processExport.content as any, fileName ?? "processDownload.csv", processExport.headers.get("Content-Type") ?? "text/csv")
        } catch (e) {
            Utilities.toastError(e);
            console.error(e);
        }
    }

    return (
        <S.FlexContainer style={{ justifyContent: "space-between" }}>
            <S.FlexContainer centerItems={true}>
                <S.ButtonGroup gap={15}>
                    {!isDefaultEnv || !props.permissions[Permissions.ProcessEdit] ? null : (
                        <>
                            <S.FlexItem flex="1 0 auto">
                                <S.LinkButton id={props.isSubprocessList ? "button-new-subprocess" : "button-new-process"} key="create-new-process" href={getNewLink()}><S.ButtonIcon className="ci-plus" /> {FRENDS.Localizations.CreateNew}</S.LinkButton>
                            </S.FlexItem>
                            {/* {props.permissions[Permissions.ProcessTemplateEdit] && (
                                <S.FlexItem flex="1 0 auto">
                                    <S.LinkButton id="create-new-process-from-template" href={"/ProcessTemplates"}>
                                        <span
                                            dangerouslySetInnerHTML={{ __html: importIcon }}
                                            style={{ height: '20px', marginRight: '10px', marginLeft: '-5px' }}
                                        /> Template import</S.LinkButton>
                                </S.FlexItem>
                            )} */}
                            <ProcessImporter key="import-process" onImport={props.doImport} onError={props.onError} />
                        </>
                    )}
                    {!props.hasNoProcesses && <S.Button title="Save all as .csv" onClick={saveAllAsCSVhandler}><i className="ci-cloud_down" /></S.Button>}
                    {!processSelected ? null :
                        <ActionMenu
                            isBatch={true}
                            labelComponent={<S.Button>{FRENDS.Localizations.Actions}&nbsp;<i className="ci-chevron_big_down" /></S.Button>}
                            processIds={props.selectedProcesses}
                        />
                    }
                </S.ButtonGroup>
            </S.FlexContainer>
            <S.FlexContainer asColumn>
                <S.Label>Filter by</S.Label>

                <S.FlexContainer style={{ gap: '20px' }}>
                    <Search />

                    {props.isSubprocessList || !props.permissions[Permissions.EnvironmentAdmin] ? null :
                        <S.Button variant={S.ButtonType.bordered} onClick={props.onShowEnvironmentLogLevelDialog} id="log-settings-selector">
                            <S.ButtonIcon className="ci-settings" /> {FRENDS.Localizations.LogSettings}
                        </S.Button>
                    }
                </S.FlexContainer>
            </S.FlexContainer>
        </S.FlexContainer>
    );
};

interface ListMenuOwnProps {
    isSubprocessList: boolean;
    selectedProcesses: number[];
}

interface ListMenuStateProps {
    currentAgentGroupName: string;
    agentGroups: AgentGroup[];
    permissions: { [activity: string]: boolean };
    hasNoProcesses: boolean,
}
interface ListMenuDispatchProps {
    onError: (message: string) => void;
    doImport: (settings: ImportSettings[], file: File) => void;
    onShowEnvironmentLogLevelDialog: () => void;
}

type ListMenuProps = ListMenuOwnProps & ListMenuStateProps & ListMenuDispatchProps;

const mapStateToProps = (state: State, ownProps: ListMenuOwnProps): ListMenuStateProps => {
    return {
        hasNoProcesses: _.isEmpty(state.processes),
        agentGroups: _.values(state.agentGroups),
        currentAgentGroupName: state.currentAgentGroupName,
        permissions: state.userPermissions
    };
};

const mapDispatchToProps = (dispatch: DispatchType<State>, ownProps: ListMenuOwnProps): ListMenuDispatchProps => {
    return {
        onError: (message: string) => Utilities.toastError(message),
        doImport: async (settings: ImportSettings[], file: File) => dispatch(await doImport(file, settings)),
        onShowEnvironmentLogLevelDialog: () => dispatch(LogLevelActions.showLogLevelSettings())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ListMenu);
